import useStore from "../../../../../lib/itn-ui-kit/data/store";
import BaseRoute from "../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../lib/itn-ui-kit/services/service-container";
import { useContactStore } from "../../../../components/modules/contacts/hooks/useContactStore";

import Template from "./template";

export default class ContactsRoute extends BaseRoute {
  @service("repositories/contact-repository") contactRepository;
  @service("repositories/field-option-repository") fieldOptionRepository;
  revalidateOnParams = ["id"];

  element = (<Template />);

  async loader({ params }) {
    const { id } = params;
    useContactStore.getState().setSearchInput("");

    let contacts = [];
    let fieldOptions = [];
    let totalCount = 0;
    let nextPage = null;
    let nextLimit = null;
    let nextOffset = null;
    let error = null;
    let loading = true;

    try {
      [contacts, fieldOptions] = await Promise.all([
        this.contactRepository.query(id, {
          limit: 25,
          offset: 0,
        }),
        this.fieldOptionRepository.query({
          content_type: "contactrelation",
          flat: "true",
        }),
      ]);

      totalCount = useStore.getState().getTotalCount("contact");
      nextPage = useStore.getState().getNextPage("contact");
      const urlObj = nextPage ? new URL(nextPage) : null;
      const urlQueryParams = urlObj ? new URLSearchParams(urlObj) : null;
      nextLimit = urlQueryParams ? urlQueryParams.get("limit") : null;
      nextOffset = urlQueryParams ? urlQueryParams.get("offset") : null;
    } catch (err) {
      console.error(err);
      error = err;
    } finally {
      loading = false;
    }

    return {
      id,
      contacts,
      fieldOptions,
      totalCount,
      nextPage,
      nextLimit,
      nextOffset,
      initialShowMore: !!nextPage,
      loading,
      error,
    };
  }
}
